"use client";

import { cn } from "@kyan/ui";
import { type ThemeName } from "@premian-labs/charting_library";
import dynamic from "next/dynamic";
import { useTheme } from "next-themes";
import React from "react";

import { useMarket } from "#/store/app/portfolio/market";
import { useIsPositionsDrawerDragged } from "#/store/app/positionsDrawer/positionsDrawerDragged";
import { type Market } from "#/types/markets";

const TradingViewChartContainer = dynamic(
  () =>
    import("./components/TradingViewChartContainer/TradingViewChartContainer").then(
      (module) => module.TradingViewChartContainer,
    ),
  { ssr: false },
);

export interface PremiaChartProps {
  className?: string;
}

const getTradingViewSymbol = (market: Market) => {
  return `${market.underlying as string}_USDC`;
};

export const PremiaChart: React.FC<PremiaChartProps> = ({ className }) => {
  const { theme } = useTheme();
  const { market } = useMarket();
  const { isPositionsDrawerDragged } = useIsPositionsDrawerDragged();

  const symbol = getTradingViewSymbol(market);

  return (
    <div
      className={cn(
        {
          "pointer-events-none": isPositionsDrawerDragged,
          "pointer-events-auto": !isPositionsDrawerDragged,
        },
        className,
      )}
    >
      <TradingViewChartContainer symbol={symbol} theme={theme as ThemeName} />
    </div>
  );
};
